module.exports = __webpack_public_path__ + "img/folder.a66ccd14.svg";